module.exports = __webpack_public_path__ + "img/home_logo.72e764df.png";